/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';

import { css, StyleSheet } from 'aphrodite';
import { Text, Header, BrandColors, Tag } from '@blend/enterprise-components';
import { cardWidth } from 'blb-styles/constants';

const styles = StyleSheet.create({
  cardContainer: {
    alignItems: 'center',
    background: BrandColors.WHITE,
    border: `1px solid ${BrandColors.CLOUD_50}`,
    borderRadius: 6,
    display: 'flex',
    flexBasis: cardWidth,
    justifyContent: 'space-between',
    maxWidth: cardWidth,
    padding: `12px 24px`,
  },
  clickable: {
    cursor: 'pointer',
  },
  header: {
    alignItems: 'center',
    display: 'flex',
  },
  headerChildren: {
    marginLeft: 8,
  },
  headerContainer: {
    alignItems: 'center',
    display: 'flex',
  },
  largePadding: {
    padding: `20px 24px`,
  },
  mediumPadding: {
    padding: `12px 24px`,
  },
  spacer: {
    marginBottom: 4,
  },
  tagWrapper: {
    marginRight: 8,
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
});

export namespace SectionCard {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {
    header: string;
    headerChildren?: React.ReactNode;
    headerTag?: string;
    id: string;
    onHeaderClick?: React.MouseEventHandler;
    sectionActions?: React.ReactNode;
    subtitle?: string;
  }
}

export const SectionCard: React.FC<SectionCard.Props> = ({
  header,
  headerChildren,
  headerTag,
  id,
  onHeaderClick,
  sectionActions,
  subtitle,
}) => (
  <div className={css(styles.cardContainer, !!subtitle ? styles.largePadding : styles.mediumPadding)} id={id}>
    <div className={css(styles.titleContainer)}>
      <div className={css(subtitle && styles.spacer, styles.headerContainer)}>
        <div className={css(onHeaderClick && styles.clickable, styles.header)} onClick={onHeaderClick}>
          {headerTag && (
            <span className={css(styles.tagWrapper)}>
              <Tag text={headerTag} theme="info" />
            </span>
          )}
          <Header size={5}>{header}</Header>
        </div>
        <div className={css(styles.headerChildren)}>{headerChildren}</div>
      </div>
      {subtitle && (
        <Text colorName="NIGHT_80" fontSize="sm" id={`${id}-subtitle`}>
          {subtitle}
        </Text>
      )}
    </div>
    <div>{sectionActions}</div>
  </div>
);
